import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockSimpleCounterFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const simpleCounterBlockConfig = {
  name: 'inner-block-simple-counter',
  component: defineAsyncComponent(() => import('./CmsSimpleCounterBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./SimpleCounter.vue')),
  fields: blockSimpleCounterFields,
} satisfies ModularBlockConfig;
